/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    // <footer class="bg-gray-900 p-6 text-center text-gray-400 flex flex-col items-center">
    //   <p>Znajdź mnie na:</p>
    //   <div class="flex gap-4 mt-2">
    //     <a
    //       href="https://www.instagram.com/_boojan_/"
    //       target="_blank"
    //       aria-label="Instagram"
    //       rel="noreferrer"
    //     >
    //       <img
    //         src="https://cdn-icons-png.flaticon.com/512/1384/1384063.png"
    //         alt="Instagram"
    //         class="w-12 h-12"
    //       />
    //     </a>
    //     <a
    //       href="https://www.facebook.com/bojaan.bojanowski"
    //       target="_blank"
    //       aria-label="Facebook"
    //       rel="noreferrer"
    //     >
    //       <img
    //         src="https://cdn-icons-png.flaticon.com/512/1384/1384053.png"
    //         alt="Facebook"
    //         class="w-12 h-12"
    //       />
    //     </a>
    //   </div>

    /* <div class="mt-6">
        <iframe
          src="https://www.instagram.com/p/DHtyWesgMnw/?img_index=1"
          width="320"
          height="440"
          frameborder="0"
          scrolling="no"
          allowtransparency="true"
          class="rounded-xl"
        ></iframe>
      </div> */

    /* </footer> */
    <footer className="bg-gray-900 text-gray-300 px-6 py-12 mt-12">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Logo i opis */}
        <div>
          <h2 className="text-2xl font-bold text-white">
            Trener Personalny Piotr Bojanowski
          </h2>
          <p className="mt-2 text-gray-400">
            Indywidualne podejście, profesjonalne wsparcie i realne efekty.
          </p>
        </div>

        {/* Linki */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Oferta</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/solo" className="hover:text-white transition">
                Treningi Solo
              </Link>
            </li>
            <li>
              <Link to="/duo" className="hover:text-white transition">
                Treningi Duo
              </Link>
            </li>
            <li>
              <Link to="/online" className="hover:text-white transition">
                Współpraca Online
              </Link>
            </li>
            <li>
              <Link to="/plan" className="hover:text-white transition">
                Plan treningowy
              </Link>
            </li>
            <li>
              <Link to="/#kontakt" className="hover:text-white transition">
                Kontakt
              </Link>
            </li>
          </ul>
        </div>

        {/* Kontakt + Sociale */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Kontakt</h3>
          <p className="text-gray-400 mb-2">📧 zbojanemtrening@gmail.com</p>
          <p className="text-gray-400 mb-4">📞 +48 796 580 777</p>

          <div className="flex gap-4 mt-4">
            <a
              href="https://www.instagram.com/_boojan_/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="hover:text-pink-500 transition"
            >
              <i className="ph ph-instagram-logo text-3xl"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Dolny pasek */}
      <div className="mt-10 border-t border-gray-700 pt-6 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} Trener Personalny. Wszelkie prawa
        zastrzeżone.
      </div>
    </footer>
  );
};

export default Footer;
